import React from "react";
import { cn } from "../lib/utils";
import { LOGO_FULL } from "./Logo";

// Exact, text-sized crop of the immutable official lockup. The wordmark occupies x=185..670 and
// y=40..108 inside the 671×132 navigation asset. Referencing that artwork through an SVG viewBox
// keeps every visible product-name mention pixel-identical to the approved logo without creating a
// second logo file or approximating its custom letterforms with a web font.
export default function BrandWordmarkText({ className, light = false }) {
  return (
    <span
      className={cn(
        "inline-flex whitespace-nowrap align-[-0.233em] leading-none",
        // Never recolour the official raster for inverse surfaces. A small neutral safe field keeps
        // the unchanged blue/orange lockup legible on midnight, cobalt and orange backgrounds.
        light && "rounded-[0.16em] bg-white px-[0.14em] py-[0.06em] shadow-[0_0_0_1px_rgba(255,255,255,0.16)]",
        className,
      )}
      translate="no"
      data-wordmark-tone={light ? "on-dark" : "standard"}
    >
      <span className="sr-only">Vidyapeeth360</span>
      <svg
        aria-hidden="true"
        className="block h-[1em] w-[7.0435em] shrink-0 overflow-hidden"
        viewBox="185 40 486 69"
        preserveAspectRatio="xMidYMid meet"
        focusable="false"
      >
        <image href={LOGO_FULL} width="671" height="132" />
      </svg>
    </span>
  );
}

export function BrandCopy({ children, className, light = false }) {
  const pieces = String(children ?? "").split("Vidyapeeth360");
  return pieces.map((piece, index) => (
    <React.Fragment key={`${piece}-${index}`}>
      {piece}
      {index < pieces.length - 1 && <BrandWordmarkText className={className} light={light} />}
    </React.Fragment>
  ));
}
